export const getReadableApiError = (error, fallbackMessage) => {
    const detail = error.response?.data?.detail;

    if (Array.isArray(detail)) {
        const messages = detail
            .map((item) => item?.msg || item?.type)
            .filter(Boolean);

        if (messages.length > 0) {
            return messages.join(" ");
        }
    }

    if (typeof detail === "string") {
        return detail;
    }

    return error.response?.data?.message || error.message || fallbackMessage;
};